module.exports = __webpack_public_path__ + "static/media/scaled.9f43d231.png";